(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["golden-boutique-hero"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('golden-campaign'))customElements.define('golden-campaign',class extends HTMLElement{
 connectedCallback(){this.abort?.abort();this.abort=new AbortController();const button=this.querySelector('button');const reduce=matchMedia('(prefers-reduced-motion: reduce)');const fine=matchMedia('(hover:hover) and (pointer:fine)');const setLight=on=>{this.toggleAttribute('data-light',on);button.setAttribute('aria-pressed',String(on))};button.hidden=false;setLight(!reduce.matches);button.addEventListener('click',()=>setLight(!this.hasAttribute('data-light')),{signal:this.abort.signal});this.addEventListener('pointermove',event=>{if(!fine.matches||reduce.matches||!this.hasAttribute('data-light'))return;this.point={x:event.clientX,y:event.clientY};if(this.frame)return;this.frame=requestAnimationFrame(()=>{this.frame=0;const rect=this.getBoundingClientRect();const x=Math.max(0,Math.min(1,(this.point.x-rect.left)/rect.width));const y=Math.max(0,Math.min(1,(this.point.y-rect.top)/rect.height));this.style.setProperty('--light-x',`${x*100}%`);this.style.setProperty('--light-y',`${y*100}%`);this.style.setProperty('--depth-x',`${(x-.5)*10}px`);this.style.setProperty('--depth-y',`${(y-.5)*6}px`)})},{passive:true,signal:this.abort.signal});const reset=()=>{this.style.removeProperty('--depth-x');this.style.removeProperty('--depth-y')};this.addEventListener('pointerleave',reset,{signal:this.abort.signal});reduce.addEventListener('change',()=>{reset();setLight(!reduce.matches)},{signal:this.abort.signal})}
 disconnectedCallback(){this.abort?.abort();cancelAnimationFrame(this.frame);this.frame=0}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["golden-category-tiles"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('golden-category-tiles')) {
  class GoldenCategoryTiles extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller=new AbortController();
      const signal=this.controller.signal;
      this.cards=Array.from(this.querySelectorAll('[data-category-tile]')).map(element=>{
        const catalog=JSON.parse(element.querySelector('[data-category-catalog]').textContent);
        return {element,catalog,frames:Array.from(element.querySelectorAll('[data-category-frame]')),active:0,current:catalog[0]?.id,visible:false,ready:false,failed:false,generation:0,cursor:0,deck:[]};
      });
      this.motion=window.matchMedia('(prefers-reduced-motion: reduce)');
      this.hovered=false;this.focused=false;
      this.addEventListener('pointerenter',e=>{if(e.pointerType==='mouse'){this.hovered=true;this.schedule();}},{signal});
      this.addEventListener('pointerleave',()=>{this.hovered=false;this.schedule();},{signal});
      this.addEventListener('focusin',()=>{this.focused=true;this.schedule();},{signal});
      this.addEventListener('focusout',()=>queueMicrotask(()=>{this.focused=this.contains(document.activeElement);this.schedule();}),{signal});
      document.addEventListener('visibilitychange',()=>this.schedule(),{signal});
      this.motion.addEventListener('change',()=>{if(!this.motion.matches)this.cards.filter(c=>c.visible).forEach(c=>this.prepare(c));this.schedule();},{signal});
      this.observer=new IntersectionObserver(entries=>{
        for(const entry of entries){const card=this.cards.find(c=>c.element===entry.target);card.visible=entry.isIntersecting;if(card.visible&&!this.motion.matches)this.prepare(card);}
        this.schedule();
      },{threshold:.2});
      this.cards.forEach(card=>{this.shuffle(card);this.observer.observe(card.element);});
    }
    disconnectedCallback(){this.controller?.abort();this.observer?.disconnect();clearTimeout(this.timer);this.cards?.forEach(c=>c.generation++);}
    shuffle(card){
      card.deck=card.catalog.slice();
      for(let i=card.deck.length-1;i>0;i--){const j=Math.floor(Math.random()*(i+1));[card.deck[i],card.deck[j]]=[card.deck[j],card.deck[i]];}
      if(card.deck.length>1&&card.deck[0].id===card.current)[card.deck[0],card.deck[1]]=[card.deck[1],card.deck[0]];
      card.cursor=0;
    }
    prepare(card){
      if(card.catalog.length<2||!card.visible||card.pending||card.ready)return;
      if(card.cursor>=card.deck.length)this.shuffle(card);
      const item=card.deck[card.cursor];const image=card.frames[1-card.active].querySelector('img');
      card.ready=false;card.failed=false;card.pending=true;card.next=item;
      const generation=++card.generation;
      image.loading='eager';image.setAttribute('fetchpriority','low');image.width=item.width;image.height=item.height;image.srcset=item.srcset;image.src=item.src;
      image.decode().then(()=>{if(this.isConnected&&card.generation===generation){card.pending=false;card.ready=!!image.naturalWidth;}},()=>{if(this.isConnected&&card.generation===generation){card.pending=false;card.failed=true;}});
    }
    schedule(){
      clearTimeout(this.timer);
      if(!this.isConnected||document.hidden||this.motion.matches||this.hovered||this.focused||!this.cards.some(c=>c.visible&&c.catalog.length>1))return;
      this.timer=setTimeout(()=>this.advance(),1000);
    }
    advance(){
      for(const card of this.cards.filter(c=>c.visible&&c.catalog.length>1)){
        if(card.failed){card.failed=false;card.cursor++;this.prepare(card);continue;}
        if(!card.ready){this.prepare(card);continue;}
        const next=1-card.active;
        card.frames[card.active].hidden=true;card.frames[card.active].removeAttribute('data-active');
        card.frames[next].hidden=false;card.frames[next].setAttribute('data-active','');
        card.active=next;card.current=card.next.id;card.cursor++;card.ready=false;
        this.prepare(card);
      }
      this.schedule();
    }
  }
  customElements.define('golden-category-tiles',GoldenCategoryTiles);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["golden-home-selection"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('golden-home-selection')) {
    customElements.define('golden-home-selection',class extends HTMLElement {
      connectedCallback() {
        if(this.ready)return;
        this.ready=true;
        this.grid=this.querySelector('[data-home-grid]');
        this.original=[...this.grid.children].map(card=>card.cloneNode(true));
        this.status=this.querySelector('[data-home-status]');
        this.originalStatus=this.status.textContent;
        this.buttons=[...this.querySelectorAll('[data-home-size]')];
        this.more=this.querySelector('[data-home-more]');
        this.all=this.querySelector('[data-home-all]');
        this.limit=Number(this.dataset.limit)||8;
        this.selected='';
        this.request=0;
        this.buttons.forEach(button=>button.addEventListener('click',()=>this.selectSize(button.dataset.homeSize)));
        this.more.addEventListener('click',()=>{this.visible+=this.limit;this.paint();});
      }
      async catalog() {
        if(this.products)return this.products;
        if(this.loading)return this.loading;
        const read=async page=>{
          const url=new URL(this.dataset.catalogUrl,window.location.origin);
          url.searchParams.set('section_id','golden-size-feed');
          url.searchParams.set('sort_by','created-descending');
          url.searchParams.set('page',String(page));
          const response=await fetch(url,{headers:{Accept:'text/html'},credentials:'same-origin'});
          if(!response.ok)throw new Error('Catalog unavailable');
          const doc=new DOMParser().parseFromString(await response.text(),'text/html');
          const feed=doc.querySelector('[data-gs-catalog]');
          if(!feed)throw new Error('Catalog missing');
          return {pages:Number(feed.dataset.pages),products:JSON.parse(feed.querySelector('[data-gs-catalog-json]').content.textContent)};
        };
        this.loading=(async()=>{
          const first=await read(1);
          if(!Number.isInteger(first.pages)||first.pages<1||first.pages>100)throw new Error('Invalid pagination');
          const products=[...first.products];
          for(let page=2;page<=first.pages;page+=4){
            const batch=[];
            for(let next=page;next<=Math.min(page+3,first.pages);next++)batch.push(read(next));
            const results=await Promise.all(batch);
            results.forEach(result=>products.push(...result.products));
          }
          this.products=[...new Map(products.map(product=>[product.id,product])).values()];
          return this.products;
        })();
        try{return await this.loading;}finally{this.loading=null;}
      }
      mix(products,size) {
        const buckets=new Map();
        const seen=new Set();
        const result=[];
        [...products].sort((a,b)=>b.created-a.created||String(b.id).localeCompare(String(a.id))).forEach(product=>{
          const variant=product.variants.find(item=>String(item.size).trim()===size);
          if(!variant||!product.image)return;
          const category=product.category||'';
          if(!buckets.has(category))buckets.set(category,[]);
          buckets.get(category).push({...product,variant});
        });
        let added=true;
        while(added){
          added=false;
          for(const bucket of buckets.values()){
            while(bucket.length&&seen.has(bucket[0].model))bucket.shift();
            if(bucket.length){const product=bucket.shift();seen.add(product.model);result.push(product);added=true;}
          }
        }
        return result;
      }
      async selectSize(size) {
        const request=++this.request;
        if(!size){this.selected='';this.grid.replaceChildren(...this.original.map(card=>card.cloneNode(true)));this.status.textContent=this.originalStatus;this.more.hidden=true;this.all.hidden=false;this.grid.removeAttribute('aria-busy');this.grid.inert=false;this.mark('');return;}
        this.grid.setAttribute('aria-busy','true');this.grid.inert=true;this.status.textContent=this.dataset.loading;this.mark(size);
        try{
          const products=await this.catalog();
          if(request!==this.request)return;
          this.results=this.mix(products,size);this.selected=size;this.visible=this.limit;this.paint();
        }catch(error){if(request===this.request){this.status.textContent=this.dataset.error;this.mark(this.selected);}}
        finally{if(request===this.request){this.grid.removeAttribute('aria-busy');this.grid.inert=false;}}
      }
      mark(size){this.buttons.forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.homeSize===size)));}
      paint(){
        const cards=this.results.slice(0,this.visible).map(product=>this.card(product));
        this.grid.replaceChildren(...cards);this.all.hidden=true;this.more.hidden=this.visible>=this.results.length;
        this.status.textContent=this.results.length?this.dataset.count.replace('[count]',this.results.length).replace('[size]',this.selected):this.dataset.empty.replace('[size]',this.selected);
      }
      card(product){
        const element=(tag,cls,text)=>{const node=document.createElement(tag);node.className=cls;if(text)node.textContent=text;return node;};
        const card=element('li','gs-home-pick');card.dataset.homeModel=product.model;
        const link=element('a','gs-home-pick__image');link.href=product.variant.url;
        const image=element('img','');image.src=product.image;image.alt=product.title;image.loading='lazy';image.width=600;image.height=750;link.append(image);
        const meta=element('div','gs-home-pick__meta');meta.append(element('p','gs-home-pick__category',product.category));
        const title=element('h3','');const titleLink=element('a','',product.title);titleLink.href=product.variant.url;title.append(titleLink);meta.append(title);
        meta.append(element('p','gs-home-pick__price',product.variant.price),element('p','gs-home-pick__size',this.dataset.sizeLabel.replace('[size]',this.selected)));
        card.append(link,meta);return card;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["golden-mood-entry"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('golden-mood-entry')) {
    customElements.define('golden-mood-entry',class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready=true;
        const dialog=this.querySelector('dialog');
        const opener=this.querySelector('[data-mood-open]');
        const preview=this.querySelector('[data-mood-preview]');
        const choices=[...this.querySelectorAll('[data-mood-choice]')];
        const showPhoto=choice=>{
          if (!choice || this.selected===choice.dataset.moodChoice) return;
          this.selected=choice.dataset.moodChoice;
          choices.forEach(link=>link.toggleAttribute('data-selected',link===choice));
          const photo=this.querySelector('[data-mood-photo="'+this.selected+'"]');
          const replace=()=>preview.replaceChildren(photo.content.cloneNode(true));
          if (photo) {
            if (document.startViewTransition && !matchMedia('(prefers-reduced-motion:reduce)').matches) document.startViewTransition(replace);
            else replace();
          }
        };
        opener.addEventListener('click',()=>{
          dialog.showModal();
          opener.setAttribute('aria-expanded','true');
          this.previousOverflow=document.documentElement.style.overflow;
          document.documentElement.style.overflow='hidden';
          if (matchMedia('(min-width:750px)').matches) showPhoto(choices[0]);
          else if (!this.thumbsReady) {
            this.querySelectorAll('[data-mood-thumb]').forEach(thumb=>{
              const photo=this.querySelector('[data-mood-photo="'+thumb.dataset.moodThumb+'"]');
              if (photo) thumb.replaceChildren(photo.content.cloneNode(true));
            });
            this.thumbsReady=true;
          }
        });
        this.querySelector('[data-mood-close]').addEventListener('click',()=>dialog.close());
        dialog.addEventListener('click',event=>{if(event.target===dialog)dialog.close();});
        dialog.addEventListener('close',()=>{
          document.documentElement.style.overflow=this.previousOverflow||'';
          opener.setAttribute('aria-expanded','false');
          opener.focus();
        });
        choices.forEach(choice=>{
          choice.addEventListener('pointerenter',()=>{if(matchMedia('(min-width:750px)').matches)showPhoto(choice);});
          choice.addEventListener('focus',()=>{if(matchMedia('(min-width:750px)').matches)showPhoto(choice);});
          choice.addEventListener('click',()=>dialog.close());
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["golden-rotating-showcase"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('golden-rotating-showcase')) {
    class GoldenRotatingShowcase extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.slides = Array.from(this.querySelectorAll('[data-showcase-slide]'));

        this.index = 0;
        this.visible = false;
        this.hovered = false;
        this.focused = false;
        this.userPaused = false;
        this.busy = false;
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.userPaused = this.motion.matches;
        if (this.slides.length < 2) return;

        this.key = 'golden-showcase-last';
        this.order = this.slides.map((_, i) => i);
        this.shuffle();
        const first = this.order[0];
        this.position = 0;
        this.change(first);

        this.addEventListener('pointerenter', event => {
          if (event.pointerType === 'mouse') { this.hovered = true; this.schedule(); }
        }, {signal});
        this.addEventListener('pointerleave', () => { this.hovered = false; this.schedule(); }, {signal});
        this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, {signal});
        this.addEventListener('focusout', () => {
          queueMicrotask(() => { this.focused = this.contains(document.activeElement); this.schedule(); });
        }, {signal});
        document.addEventListener('visibilitychange', () => this.schedule(), {signal});
        window.addEventListener('pageshow', event => {
          if (!event.persisted) return;
          this.hovered = false;
          this.focused = false;
          this.advance();
        }, {signal});
        this.motion.addEventListener('change', () => { this.userPaused = this.motion.matches;  this.schedule(); }, {signal});
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting;
          this.schedule();
        }, {threshold: .15});
        this.observer.observe(this);
        
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        clearTimeout(this.timer);
      }
      shuffle() {
        for (let i = this.order.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [this.order[i], this.order[j]] = [this.order[j], this.order[i]];
        }
        let last;
        try { last = sessionStorage.getItem(this.key); } catch {}
        if (this.slides[this.order[0]].dataset.productId === last) {
          [this.order[0], this.order[1]] = [this.order[1], this.order[0]];
        }
      }

      schedule() {
        clearTimeout(this.timer);
        if (!this.isConnected || !this.visible || document.hidden || this.hovered || this.focused || this.userPaused || this.busy) return;
        this.timer = setTimeout(() => this.advance(), Number(this.dataset.interval));
        this.preload(this.order[(this.position + 1) % this.order.length]);
      }
      preload(index) {
        const img = this.slides[index]?.querySelector('img');
        if (img) img.loading = 'eager';
      }
      async change(index) {
        this.busy = true;
        this.preload(index);
        const slide = this.slides[index];
        const img = slide.querySelector('img');
        try { await img?.decode(); } catch {}
        if (!this.isConnected) return;
        if (!img?.naturalWidth) { this.busy = false; this.schedule(); return; }
        if (this.hovered || this.focused) {
          this.busy = false;
          this.schedule();
          return;
        }
        this.slides.forEach((item, i) => { item.hidden = i !== index; });
        this.index = index;
        try { sessionStorage.setItem(this.key, slide.dataset.productId); } catch {}
        this.busy = false;
        this.schedule();
      }
      advance() {
        if (this.busy) return;
        this.position = (this.position + 1) % this.order.length;
        this.change(this.order[this.position]);
      }
    }
    customElements.define('golden-rotating-showcase', GoldenRotatingShowcase);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
